module.exports = __webpack_public_path__ + "img/download-icon.2ebff79e.svg";